// extracted by mini-css-extract-plugin
module.exports = {"list":"formattedHtml_list__AQF5S"};